// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import Modal from './Modal';
import api from '../../api';

export default class VerifyLogin extends Modal {

    state = {
        token: ""
    }

    verifyCode = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        await this.props.loading(1005);
        const { userId, persist, team } = this.props.match?.params??this.props;

        const { token } = this.state;

        const res = await api.post('/user/verify', { userId, persist, token, team });
        if (this.props.switchingTeam && res && res.success && res.user && res.team) {
            const team = res.team._id
            // Update cookies
            const resSwitched = await api.post('/user/switchTeam', { team }); // Need to skip this if logging in for first time, but still run loginUser
            this.props.login(resSwitched.user, resSwitched.team);
            window.location.href = '/';
        } else if (res && res.success) {
            this.props.login(res.user, res.team);

            const query = new URLSearchParams(window.location.search);
            const redirect = query.get('redirect');
            const exchange = query.get('exchange');

            window.location.href = redirect && redirect !== "" ? (redirect + (exchange ? "?code=" + res.code : "")) : "/";
        } else {
            toast.error("Invalid verification code!");
            this.props.loaded();
        }
    }

    renderContent = () => {
         
        return (<div className="modal-content modal-center">
            
            <br /><br />

            <h1>Verify your identity</h1>

            <h2>Two-Factor Authentication</h2>

            <p style={{ width: 660, margin: '0 auto' }}>
                Your team has opted to use {this.props.method === "email" ? "Email" : this.props.method ? "SMS" : this.props.method} <strong>Two-Factor Authentication (2FA)</strong> for added security. We just sent you an email with a <strong>6-digit</strong> code. Please <u>enter that code below</u> to login.
            </p>

            <h2>What's your verification code?</h2>

            <form onSubmit={this.verifyCode}>

                <input
                    type="text"
                    className="login-verify-code"
                    placeholder="XXXXXX"
                    autoFocus={true}
                    value={this.state.token}
                    onChange={(e) => this.setState({
                        token: e.target.value.substr(0,6).toUpperCase()
                    })}
                />

                <br />

                <div
                    className="login-resend-code"
                    onClick={()=>this.props.resendCode(this.props.team)}
                >Resend code</div>

                <br />

                <input
                    type="submit"
                    value="Verify Code"
                    style={{ float: 'none', clear: 'both' }}
                />
            
            </form>
            
        </div>);
    }

};